<template>
  <statistics-card-line
    style="height:150px"
    :key="key"
    v-if="extractedData"
    :icon="icon"
    :color="color"
    :statisticTitle="label"
    :statistic="extractedData.value"
    :chartData="extractedData.series"
    :additionalChartOptions="extractedData.options"
    hide-chart
    type="bar"/>
</template>

<script>

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine';

export default {
  name: 'referrals-statistics-card',
  components: {StatisticsCardLine},
  props: {
    data: Object,
    program: String,
    label: String,
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'UsersIcon'
    }
  },
  data () {
    return {
      extractedData: null,
      key:0
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler (value) {
        this.key++;
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const count = allTime.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT');
        const referrals = allTime.nested.find(n => n.name === 'REFERRALS');
        const programs = allTime.nested.find(n => n.name === 'PROGRAMS');
        this.extractedData = {
          value: !this.program ? count.value : (programs.buckets.find(b => b.key === this.program) && programs.buckets.find(b => b.key === this.program).nested.find(n => n.name === 'ACTIVE') && programs.buckets.find(b => b.key === this.program).nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT') ? programs.buckets.find(b => b.key === this.program).nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT').value : 0),
          options: {
            yaxis: {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: {
                left: 0,
                right: 0
              },
              max: Math.max(...referrals.buckets.map(b => b.count)) + 10
            }
          },
          series: [
            {
              name: this.$t('reports.global.referrals'),
              data: referrals.buckets.map(o => {
                let value = null;
                if (this.program) {
                  const program = o.nested.find(n => n.name === 'PROGRAMS');
                  const bucket = program.buckets.find(b => b.key === this.program);
                  value = bucket ? bucket.count : 0;
                } else {
                  value = o.count;
                }
                return [Number.parseFloat(o.key), value];
              })
            }
          ]
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
